import { Divider } from "antd"
import { useSelector } from "react-redux"

import InfoBlock from "./components/InfoBlock"
import Share from "./components/Share"
import YourCommission from "./components/YourCommission"

const Invite = () => {
  const isMobile = useSelector((state) => state.nav.isMobile)
  return (
    <div>
      <Share />
      <Divider style={{ visibility: isMobile && "hidden", margin: isMobile && "12px 0" }} />
      <YourCommission />
      <Divider style={{ visibility: isMobile && "hidden", margin: isMobile && "12px 0" }} />
      <InfoBlock />
    </div>
  )
}

export default Invite
